import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';

export default function ProductImage({
  src,
  alt = '',
  className = '',
  loading = 'lazy',
  decoding = 'async',
  fallbackText = 'Нет фото',
  fallbackIconSize = 22,
  onError,
  ...imageProps
}) {
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setFailed(!src);
  }, [src]);

  if (failed) {
    return (
      <span
        className={`product-media-fallback ${className}`.trim()}
        role={alt ? 'img' : undefined}
        aria-label={alt || undefined}
        aria-hidden={alt ? undefined : 'true'}
      >
        <ImageOff size={fallbackIconSize} />
        <small>{fallbackText}</small>
      </span>
    );
  }

  return (
    <img
      {...imageProps}
      className={className}
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      onError={(event) => {
        setFailed(true);
        onError?.(event);
      }}
    />
  );
}
